import { InlineForm, InlineValueOrType, InlineOptions } from "./inline-form";
import { FormModel, BasicFormFieldValue } from "../form-model";
import { SubType } from "../../form-settings/sub-type";

type ValueResolverResult = { match: boolean; value?: BasicFormFieldValue };
type ValueResolver = (valueOrType: InlineValueOrType, factory: Function) => ValueResolverResult;

const ArrayResolver: ValueResolver = (valueOrType: InlineValueOrType) => {
  return {
    match: Array.isArray(valueOrType),
    value: []
  };
};

const GroupResolver: ValueResolver = (valueOrType: InlineValueOrType, factory: Function) => {
  if (typeof valueOrType !== "object" || valueOrType instanceof SubType) {
    return {
      match: false
    };
  }

  return {
    match: true,
    value: Object.entries(valueOrType).reduce(
      (formModel, [id, options]) => ({ ...formModel, [id]: factory(options) }),
      {}
    )
  };
};

/**
 * Given an inline form it will resolve the model. No default values are used.
 *
 * Note: InlineOptions might have a default value in the future
 */
export class InlineModelResolver {
  private readonly resolvers: ValueResolver[] = [ArrayResolver, GroupResolver];
  public resolve(inlineForm: InlineForm) {
    return this.resolveInlineOptions([null, inlineForm]);
  }

  private resolveInlineOptions([, child]: InlineOptions): FormModel {
    return (
      (this.resolvers.reduce<ValueResolverResult>(
        (prev, curr) => (prev.match ? prev : curr(child, this.resolveInlineOptions.bind(this))),
        {
          match: false,
          value: null
        }
      ).value as FormModel) || null
    );
  }
}
